import productApprovalsApi from 'ui-product-approvals/data/productApprovalsApi';
const approvalType = 'MARKETING_EMAIL';
const approvalAction = 'PUBLISH';
export function fetchApprovalsConfigRequest() {
  return productApprovalsApi.fetchProductApprovalsConfig({
    approvalAction,
    approvalType
  });
}